import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ConsulterModel } from 'app/model/consulter.model';
import { ConsultService } from 'app/services/consult/consult.service';
import { MasterService } from 'app/services/master/master.service';
import { FormStatus } from 'app/components/form-status/form-status.constants';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormBaseComponent } from 'app/components/form/form-base.component';
import { PaymentRequiredError } from 'app/exception/payment-required.error';
import { NotFoundError } from 'app/exception/notfound.error';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
    selector: 'form-consulter',
    templateUrl: './form-consulter.component.html',
    styleUrls: ['./form-consulter.component.scss']
})
export class FormConsulterComponent extends FormBaseComponent implements OnInit {

    /** 日付入力設定 */
    datepickerOpts: object;

    /** 被害日時 */
    injuryDate: Date;

    dataPipe: DatePipe;

    @Input()
    referenceNum: string;

    /** 参照する時、権限なしエラーが発生した場合、ログインのガイドを表示するか */
    @Input()
    showLoginGuide: boolean;
    loginGuideMsg: string;
    loginGuideOpened: boolean = false;

    @Output()
    statuschange = new EventEmitter();

    title: string;

    status: string;

    /** 相談情報 */
    consulterInfo: ConsulterModel & {harassmentTypeName?: string, consultantName?: string, injuryTimeName?: string };
    consulterValid: ConsulterModel & {all: string};

    /** google reCAPTCHA */
    recaptcha: string;
    @ViewChild('recaptchaModal') recaptchaModal: ModalDirective;
    
    /** 入力・表示モード */
    editable: boolean;
    confirmation: boolean;

    /** 参照用パスワード */
    referencePassword: string;
    referencePasswordError: string;
    @ViewChild('referencePasswordModal') referencePasswordModal: ModalDirective;

    constructor(
        private consultService: ConsultService, 
        private masterService: MasterService,
        private router: Router) {

        super();
        this.consulterInfo = new ConsulterModel();
        this.consulterValid = Object.assign( new ConsulterModel() , {all: ''});
        
        this.dataPipe = new DatePipe('en-US');
        this.datepickerOpts = {
            startDate: null,
            endDate: new Date(),
            autoclose: true,
            todayBtn: 'linked',
            todayHighlight: true,
            assumeNearbyYear: true,
            format: 'yyyy/mm/dd',
            language: 'ja',
            placeholder: '日付入力',
            icon: 'fa fa-calendar'
        }
    }

    
    async ngOnInit() {
        
        try {
            
            if (this.referenceNum) {
                this.loading.emit(true);

                let res: {status: string; title: string} & ConsulterModel = await this.consultService.getConsulter(this.referenceNum, this.referencePassword);
                this.status = res.status;
                this.title = res.title;
                this.consulterInfo = res;
                this.editable = this.status == FormStatus.None ? true : false;

                this.syncItemName();

                // 日本時間を設定
                if (res.injuryDate && res.injuryDate.length > 0) {
                    this.injuryDate = new Date(res.injuryDate + ' GMT+0900');
                }

                // ステータス通知
                if (this.status) {
                    this.statuschange.emit(this.status);
                }
            } else {
                this.consulterInfo = new ConsulterModel();
                this.editable = true;
            }

            this.confirmation = false;

        } catch(err) {

            if (err instanceof PaymentRequiredError) {
                this.loading.emit(false);
                window.setTimeout(() => {

                    if (this.showLoginGuide) {
                        this.openLoginGuide();
                    } else {
                        this.openReferencePasswordModalDialog(err.message);
                    }
                }, 300);

            } else if (err instanceof NotFoundError) {
                this.router.navigate(['/pages/404']);
                
            } else {
                this.alert('danger', err.message);
            }
            
        } finally {
            this.loading.emit(false);
        }
    }


    /**
     * 参照用パスワードを使って、もう一回初期処理を行う。
     */
    reloadByAuthenticationCode() {
        if (this.referencePassword && this.referencePassword.length > 0) {
            this.referencePasswordModal.hide();
            this.ngOnInit();
        }
    }

    /**
     * 入力チェック処理
     */
    validateForm(form) {
        if (form.invalid)  {
            this.consulterValid.all = 'true';
            return;
        }

        console.log(this.recaptcha);

        this.syncItemName();
        this.editable = false;
        this.confirmation = true;
    }

    /**
     * 相談情報送信処理
     */
    async createConsulter() {

        if(!this.recaptcha) {
            this.recaptchaModal.show();
            return;
        }

        try {
            this.loading.emit(true);

            this.consulterInfo.injuryDate = this.dataPipe.transform(this.injuryDate, 'yyyy/MM/dd');
            await this.consultService.createConsulter(this.consulterInfo, this.recaptcha);
            this.confirmation = false;
            this.recaptcha = null;
        
            // ステータスを通知
            this.status = FormStatus.ConfirmingFact;
            this.statuschange.emit(this.status);

            this.alert('success', '相談内容を提出しました。', 7000);

        } catch(err) {
            this.alert('danger', err.message);
            console.error(err);
        } finally {
            this.loading.emit(false);
        }
    }

    private async syncItemName() {
        this.consulterInfo.harassmentTypeName = await this.masterService.getHarassmentTypeName(this.consulterInfo.harassmentType);
        this.consulterInfo.consultantName = await this.masterService.getConsultantName(this.consulterInfo.consultantMail);
        this.consulterInfo.injuryTimeName = await this.masterService.getInjuryTimeName(this.consulterInfo.injuryTime);
    }

    /**
     * 参考パスワード入力用ダイアログ
     * @param msg 
     */
    private openReferencePasswordModalDialog(msg: string) {
        this.referencePasswordError = msg;
        this.referencePasswordModal.show();
    }


    private openLoginGuide() {
        this.loginGuideMsg = '相談情報を確認するにはログインしてください';
        this.loginGuideOpened = true;
    }

    public recaptchaResolved(response: string) {
        if (response && response.length > 0) {
            this.recaptchaModal.hide();
            this.createConsulter();
        }
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-consulter/form-consulter.component.ts